export default "__VITE_ASSET__BmTd$tfc__"